import { Component, Input, OnInit } from '@angular/core';
import { CmsComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Iframe } from './iframe.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'iframe-viewer',
  templateUrl: './iframe.component.html',
  styleUrl: './iframe.component.scss',
  standalone: false,
})
export class IframeComponent implements OnInit {
  @Input() iframe?: Iframe;
  subscription = new Subscription();

  constructor(private componentData: CmsComponentData<CmsComponent>) {}

  ngOnInit(): void {
    !this.iframe && this.getContent();
  }

  getContent() {
    this.subscription.add(
      this.componentData.data$.subscribe((data: any) => {
        this.iframe = {
          url: data.url,
        };
      }),
    );
  }
}
